import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import {
  apiActionResult,
  apiActions as commonApiActions,
  apiResourceActionCreator
} from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import getBusinessSyncStatusConfig from './getBusinessSyncStatus';

const actions = createActions({
  TASK: {
    TRIGGER_BUSINESS_SYNC: (businessId) => ({ businessId }),
    API: {
      TRIGGER_BUSINESS_SYNC: apiResourceActionCreator('task')
    }
  }
});

export const apiAction = (authToken, businessId) =>
  commonApiActions.authenticated.post(
    `${API_ENDPOINT}/business-tasks/${businessId}/sync`,
    authToken,
    {},
    actions.task.api.triggerBusinessSync
  );

/**
 * Saga worker that triggers a business task synchronization and
 * initiates the polling sequence for its real-time status.
 */
function* triggerBusinessSync(action) {
  const authToken = yield select(authTokenSelector);
  const { businessId } = action.payload;

  yield put(apiAction(authToken, businessId));

  yield apiActionResult(actions.task.api.triggerBusinessSync);

  yield put(
    getBusinessSyncStatusConfig.action.task.getBusinessSyncStatus(
      businessId,
      true
    )
  );
}

/**
 * Redux configuration mapping action creators, asynchronous sagas,
 * and state slice reducers for triggering business-level task synchronizations.
 */
const configuration = {
  name: 'triggerBusinessSync',
  action: actions,
  sagas: triggerBusinessSync,
  reducers: {
    request: (state) => ({
      ...state,
      isTriggeringBusinessSync: true,
      is429Error: null
    }),
    success: (state) => ({
      ...state,
      isTriggeringBusinessSync: false,
      is429Error: null
    }),
    failed: (state, action) => {
      const is429Error =
        action &&
        action.meta &&
        action.meta.response &&
        String(action.meta.response.status) === '429';

      return {
        ...state,
        isTriggeringBusinessSync: false,
        businessSyncStatus: is429Error ? state.businessSyncStatus : 'FAILED',
        is429Error: is429Error
      };
    }
  }
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/triggerBusinessSync.js